import {ref} from 'vue';

export default {
    install: (app, options) => {
        const companyTypes = ref([]);

        const loadCompanyTypes = (types = '') => {
            // if (companyTypes.value.length === 0) {
                window.lazy_axios.get('/company-types?types=' + types)
                    .then((response) => {
                        if (response.data.company_types) {
                            companyTypes.value = response.data.company_types;
                            // document.dispatchEvent(new CustomEvent('loaded.company_types'));
                        }
                    });
            // }
        };

        app.provide('profileCompanyTypes', companyTypes);
        app.provide('loadProfileCompanyTypes', loadCompanyTypes);



        const companySegments = ref([]);

        const loadCompanySegments = () => {
            // if (companyTypes.value.length === 0) {
                window.lazy_axios.get('/company-segments')
                    .then((response) => {
                        if (response.data.company_segments) {
                            companySegments.value = response.data.company_segments;
                        }
                    });
            // }
        };

        app.provide('profileCompanySegments', companySegments);
        app.provide('loadProfileCompanySegments', loadCompanySegments);


        const distributors = ref([]);

        const loadDistributors = () => {
            if (distributors.value.length === 0) {
                window.lazy_axios.get('/companies/distributors')
                    .then((response) => {
                        if (response.data.distributors) {
                            distributors.value = response.data.distributors;
                        }
                    });
            }
        };

        app.provide('distributors', distributors);
        app.provide('loadDistributors', loadDistributors);


        const dealers = ref([]);

        const loadDealers = () => {
            if (dealers.value.length === 0) {
                window.lazy_axios.get('/companies/dealers?all=true')
                    .then((response) => {
                        if (response.data.dealers) {
                            dealers.value = response.data.dealers.data;
                        }
                    });
            }
        };

        app.provide('dealers', dealers);
        app.provide('loadDealers', loadDealers);
    },
}
